import { TunnelDataContext } from "../../../digital-journey/context/TunnelDataContext"
import useCreateOrder from "../../../hooks/useCreateOrder"
import useSimulationSubmit from "./useSimulationSubmit"
import { useContext, useEffect } from "react"

export default function useSimulationPage() {
  const { tunnelData } = useContext(TunnelDataContext)

  const {
    isLoading,
    product,
    setProduct,
    quantity,
    packContext,
    selectedPack,
    simulationSubmitNoUseCallBack,
    changePackContext
  } = useSimulationSubmit()

  const {
    createOrder,
    isLoading: isLoadingCreateOrder,
    showBasket,
    showCreateOrderButton
  } = useCreateOrder({ tunnelData })

  useEffect(() => {
    changePackContext({
      isRetail: true
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const packToTunnelData = (pack) => {
    if (!pack)
      return {
        ...tunnelData
      }
    return {
      ...tunnelData,
      data: {
        order: {
          orderLanguageTag: tunnelData.lang,
          promotionDTOs: [],
          rent: pack.rentDTO,
          selectedServicePack: pack.servicePackDTO,
          products: packContext?.product ? packContext?.product : []
        },
        quantity
      },
      displayHeaderPrice: tunnelData.displayHeaderPrice,
      displayBasketQuantity: tunnelData.displayBasketQuantity,
      displayotherInformationsBasket: tunnelData.displayotherInformationsBasket,
      tenant: tunnelData.tenant
    }
  }

  function handleSimulationSubmit(values) {
    simulationSubmitNoUseCallBack(values, selectedPack?.rentDTO?.duration)
  }

  return {
    createOrder,
    isLoadingCreateOrder,
    showBasket,
    showCreateOrderButton,
    packToTunnelData,
    product,
    setProduct,
    handleSimulationSubmit,
    isLoading,
    selectedPack,
    quantity,
    packContext
  }
}
